import React, { useEffect } from 'react';
import Template from '../../../BankFailure/Template/Template';
import BankCautionIcon from 'src/assets/images/bank_caution-icon.svg';
import '../../../BankFailure/BankFailure.scss';
import { PATH_LINK, STEP_MANUAL } from '../../../AddBank/AddBank';
import { dispatchPageLoad } from '../../../../../redux/utils/analytics-helper';

export const Verified = ({ handleClose, setBankProgress, path }) => {
  useEffect(() => {
    dispatchPageLoad(
      path === PATH_LINK ? 'ExistingBankPlaid' : 'ExistingBankManual'
    );
  }, [path]);
  return (
    <div>
      <Template
        image={BankCautionIcon}
        header={`This bank is already on file.`}
        msg={
          <div>
            This bank is already available for use. Would you like to add
            another bank?
          </div>
        }
        nextButton={`Yes, Add Another Bank`}
        onNextClick={() => setBankProgress(STEP_MANUAL)}
        textOffRamp={`Cancel`}
        nextDestination={() => handleClose()}
      />
    </div>
  );
};

export default Verified;
